import {useFormik} from 'formik'
import React, {useEffect, useState} from 'react'
import {State} from 'country-state-city'
import {Col, Modal, Row, Spinner, Stack} from 'react-bootstrap'
import {createPortal} from 'react-dom'
import SVG from 'react-inlinesvg'
import * as Yup from 'yup'
import {defaultProductDetails, solarProductDetails} from './AddProductInterface'
import closeSymbol from '../../../../../_metronic/images/closeSymbol.svg'
import {useLazyQuery, useMutation} from '@apollo/client'
import {
  GET_PRODUCT_DETAILS,
  CREATE_PRODUCT,
  UPDATE_PRODUCT,
  GET_ALL_SCRIPTS_LIST,
  GETCLIENTFEATUREFLAGS,
  GET_SOLAR_PRODUCT_BY_ID,
} from '../../../../../utils/GraphQLAPI'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import 'react-datepicker/dist/react-datepicker.css'
import {alert, uploadFiles} from '../../../../../utils/helper'
import './AddProduct/AddProduct.css'
import {MultiSelect} from 'react-multi-select-component'
import DragDrop from '../../../../sharedComponent/UploadDrag'
import {PdfPreview} from '../../../../sharedComponent/Preview'
//validations
import {basicValidations, billingMethodOptions, solarbasicValidations} from './AddProductUtils'
import ToggleButton from '../../../../sharedComponent/ToggleButton'
import {GLOBAL_CONSTANTS} from '../../../../../utils/GlobalConstants'
import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'

const MySwal = withReactContent(Swal)

type Props = {
  show: boolean
  handleClose: () => void
  method: string
  editId: string
  refetchProduct: () => void
}
const networkOnly = 'network-only'
const modalsRoot = document.getElementById('root-modals') || document.body
const fileUploadFileType = ['pdf']
const SolarProductModal = ({show, handleClose, method, editId, refetchProduct}: Props) => {
  const [utilityData, setUtilityData] = useState<any>()
  const [productType, setProductType] = useState<any>()
  const [state, setState] = useState<any>()

  const [dealSourceTier, setDealSourceTier] = useState<any>()
  const [status, setStatus] = useState<string>('Add')
  const [activeStatus, setActiveStatus] = useState<any>(true)
  const [lmiApproved, setLmiApproved] = useState('')
  const [benefitProgram, setbenefitProgram] = useState<any>()
  const limStatus = lmiApproved ? lmiApproved.toString().includes('Upload Docs') : false
  console.log(lmiApproved, '>>>>lmiApproved')
  const [customerTypeData, setCustomerTypeData] = useState<{label: string; value: string}[]>([
    {label: 'B2B', value: 'B2B'},
    {label: 'Residential', value: 'Residential'},
  ])
  const [selectedProgram, setSelectedProgram] = useState([])
  const benefitProgaramModifications = benefitProgram?.map((eachBenefitProgram: any) => ({
    value: eachBenefitProgram.id,
    label: eachBenefitProgram.value,
  }))
  const noteList = [{fieldName: 'note1', placeHolderText: 'Note 1'}]
  const [tpvScript, setTpvScript] = useState<any>([])
  const [validationSchema, setValidationSchema] = useState<any>({
    ...solarbasicValidations,
  })
  const [submitting, setSubmitting] = useState(false)
  const [TC, setTC] = useState<File | null>(null)
  const [EFL, setEFL] = useState<File | null>(null)
  const [otherFile, setOtherFile] = useState<File | null>(null)
  useEffect(() => {
    if (method === 'Create') {
      formik.setValues({...defaultProductDetails})
      setStatus('Add')
      setActiveStatus(true)
    } else if (method === 'edit' || method === 'clone') {
      getProductById()
      setStatus(method === 'edit' ? 'Edit' : 'Clone')
    }

    getClientFeatureFlags()
    getCustomerData()
    getAllScripts()
    formik.resetForm()
  }, [editId, method, show])

  //to get the feature flags from TPV admin
  const [getClientFeatureFlags, {data: featureFlags}] = useLazyQuery(GETCLIENTFEATUREFLAGS, {
    fetchPolicy: 'network-only',
  })
  //to get the product setup values to populate the dropdown

  const [getCustomerData] = useLazyQuery(GET_PRODUCT_DETAILS, {
    onCompleted: (data) => {
      setCustomerTypeData(data?.getProductDetail[4]?.names)
      setUtilityData(data?.getProductDetail[1]?.names)
      setProductType(data?.getProductDetail[6]?.names)
      setbenefitProgram(data?.getProductDetail[8]?.names)
      // setState(data?.getProductDetail[7]?.names)
      setDealSourceTier(data?.getProductDetail[7]?.names)
    },
    fetchPolicy: networkOnly,
  })
  useEffect(() => {
    const getAllStates = State.getStatesOfCountry('US')
    setState(getAllStates.map((eachState) => ({id: eachState.isoCode, value: eachState.name})))
  }, [])
  const [getAllScripts] = useLazyQuery(GET_ALL_SCRIPTS_LIST, {
    fetchPolicy: networkOnly,
    variables: {
      getScriptsInput: {
        commodityId: null,
        isActive: true,
        languageId: null,
        salesChannelId: null,
        searchText: '',
        utilityId: null,
      },
    },
    onCompleted: (data) => {
      setTpvScript(data.getAllScripts.scripts)
    },
  })
  const [addProduct] = useMutation(CREATE_PRODUCT, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnlyMutation,
    onCompleted: () => {
      alert('Product added successfully', 'success')
      handleModalClose()
      refetchProduct()
      handleModalClose()
      setSubmitting(false)
    },
    onError: (e) => {
      alert(e.message, 'error')
      setSubmitting(false)
    },
  })

  const [updateProduct] = useMutation(UPDATE_PRODUCT, {
    fetchPolicy: networkOnly,
    onCompleted: (data) => {
      const options: any = {
        customClass: {
          popup: 'swal2-border-radius',
        },
        title: 'Product updated successfully',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      }
      MySwal.fire(options)
      refetchProduct()
      handleModalClose()
      setSubmitting(false)
    },
    onError: (e) => {
      alert(e.message, 'error')
      setSubmitting(false)
    },
  })
  //to set field value for dropdown
  const handleSelectedItem = (e: any, name: any) => {
    if (e.value.length > 0) {
      formik.setFieldValue(name, e.label)
      formik.setFieldValue(`${name}Id`, e.value)
    } else {
      formik.setFieldValue(name, '')
      formik.setFieldValue(`${name}Id`, null)
    }
  }

  const [getProductById, {data: getProductByIdData, loading}] = useLazyQuery(
    GET_SOLAR_PRODUCT_BY_ID,
    {
      fetchPolicy: networkOnly,
      variables: {
        id: editId,
      },
      onCompleted: (productData) => {
        setLmiApproved(productData?.getProductById?.lmiApproved)
        setSelectedProgram(
          benefitProgram
            .filter((program: any) =>
              productData?.getProductById?.benefitPrograms?.some(
                (item: any) => item.id === program.id
              )
            )
            .map((editValue: any) => ({value: editValue.id, label: editValue.value}))
        )
        console.log(productData, '>>>>productData')
        const editProductEnrollment = {
          productName: productData.getProductById.name || '',
          id: productData.getProductById.id || '',
          product: productData.getProductById.solarProduct
            ? productData.getProductById.solarProduct.name
            : '',
          productId: productData.getProductById.solarProduct
            ? productData.getProductById.solarProduct.id
            : '',
          customerType: productData.getProductById.customerType
            ? productData.getProductById.customerType.name
            : '',
          customerTypeId: productData.getProductById.customerType
            ? productData.getProductById.customerType.id
            : '',
          solarFarmName: productData.getProductById.solarFarmName || '',
          billingMethod: Boolean(productData.getProductById.ebillingMethod)
            ? productData.getProductById.ebillingMethod
            : '',
          discount: productData.getProductById.discountPercentage || '',
          dealSourceTier: productData.getProductById.dealSourceTier
            ? productData.getProductById.dealSourceTier.name
            : '',
          dealSourceTierId: productData.getProductById.dealSourceTier
            ? productData.getProductById.dealSourceTier.id
            : '',

          availableCustomers: productData.getProductById.availableCustomers || '',
          creditCheckRequired: productData.getProductById.creditCheckRequired ? 'YES' : 'NO',
          state: productData.getProductById.state || '',
          utility: productData.getProductById.utility
            ? productData.getProductById.utility.name
            : '',
          utilityId: productData.getProductById.utility
            ? productData.getProductById.utility.id
            : '',
          productStatus: productData.getProductById.isActive || '',
          note1: productData.getProductById.notes || '',
          scriptId: productData.getProductById.script
            ? productData.getProductById.script.scriptId
            : '',
          script: productData.getProductById.script ? productData.getProductById.script.name : '',
        }
        setTC(
          productData.getProductById?.productFiles.filter((file: any) => file?.position === 0)[0]
            ?.fileUrl
        )
        setEFL(
          productData.getProductById?.productFiles.filter((file: any) => file?.position === 1)[0]
            ?.fileUrl
        )
        setOtherFile(
          productData.getProductById?.productFiles.filter((file: any) => file?.position === 2)[0]
            ?.fileUrl
        )
        formik.setValues({...editProductEnrollment})
      },
    }
  )

  const formik: any = useFormik({
    initialValues: solarProductDetails,
    validationSchema: Yup.object().shape(validationSchema),
    enableReinitialize: true,
    onSubmit: async (values) => {
      setSubmitting(true)
      let formData: any = {
        name: values.productName || null,
        solarProductId: formik.getFieldMeta('productId').value || null,
        customerTypeId: formik.getFieldMeta('customerTypeId').value || null,
        solarFarmName: values.solarFarmName || null,
        ecode: `${values.productName}-${values.customerType}-${values.state}-${values.utility}-${values.product}-${values.dealSourceTier}`,
        ebillingMethod: values.billingMethod || null,
        discountPercentage: values.discount ? Number(values.discount) || null : null,
        dealSourceTierId: formik.getFieldMeta('dealSourceTierId').value
          ? formik.getFieldMeta('dealSourceTierId').value || null
          : null,
        availableCustomers: values.availableCustomers
          ? Number(values.availableCustomers) || null
          : null,
        creditCheckRequired: values.creditCheckRequired === 'Yes' ? true : false,
        state: formik.getFieldMeta('state').value || null,
        utilityId: formik.getFieldMeta('utilityId').value
          ? formik.getFieldMeta('utilityId').value || null
          : null,
        isActive: activeStatus,
        notes: values.note1 || null,
        scriptId: formik.getFieldMeta('scriptId').value
          ? formik.getFieldMeta('scriptId').value || null
          : null,
        benefitPrograms: selectedProgram
          ? selectedProgram.map((benefitvalue: any) => ({id: benefitvalue.value || ''}))
          : null,
      }
      if (method === 'Create' || method === 'clone') {
        let TCUrl, EFLUrl, OtherUrl
        let productFiles = []
        if (method === 'clone') {
          productFiles = getProductByIdData?.getProductById?.productFiles.map((data: any) => ({
            fileUrl: data.fileUrl,
            position: data.position,
          }))
        }
        if (method === 'Create') {
          if (Boolean(TC)) {
            TCUrl = await uploadFiles(
              [TC],
              false,
              '',
              `Productfiles/${values.productName.replaceAll(' ', '-')}`
            )
            console.log('TCURL----', TCUrl)
            productFiles.push({
              fileUrl: TCUrl[0],
              position: 0,
            })
          }
          if (EFL) {
            EFLUrl = await uploadFiles(
              [EFL],
              false,
              '',
              `Productfiles/${values.productName.replaceAll(' ', '-')}`
            )
            productFiles.push({
              fileUrl: EFLUrl[0],
              position: 1,
            })
          }
          if (otherFile) {
            OtherUrl = await uploadFiles(
              [otherFile],
              false,
              '',
              `Productfiles/${values.productName.replaceAll(' ', '-')}`
            )
            productFiles.push({
              fileUrl: OtherUrl[0],
              position: 2,
            })
          }
        }
        await addProduct({
          variables: {
            createProductInput: {
              ...formData,
              productFiles,
            },
          },
        })
      } else if (method === 'edit') {
        const TCSameAsApiData =
          getProductByIdData.getProductById?.productFiles.filter(
            (file: any) => file?.position === 0
          )[0]?.fileUrl === TC
        const productFiles = []

        let TCUrl, EFLUrl, OtherUrl

        //to check whether the file is same as API data, if not we have to upload it to the S3 bucket
        if (!TCSameAsApiData) {
          if (TC) {
            TCUrl = await uploadFiles(
              [TC],
              false,
              '',
              `Productfiles/${values.productName.replaceAll(' ', '-')}`
            )
            productFiles.push({
              fileUrl: TCUrl[0],
              position: 0,
            })
          } else {
            productFiles.push({
              fileUrl: '',
              isDelete: true,
              position: 0,
            })
          }
        }
        //to check whether the file is same as API data, if not we have to upload it to the S3 bucket
        const EFLSameAsApiData =
          getProductByIdData.getProductById?.productFiles.filter(
            (file: any) => file?.position === 1
          )[0]?.fileUrl === EFL
        if (!EFLSameAsApiData) {
          if (EFL) {
            EFLUrl = await uploadFiles(
              [EFL],
              false,
              '',
              `Productfiles/${values.productName.replaceAll(' ', '-')}`
            )
            productFiles.push({
              fileUrl: EFLUrl[0],
              position: 1,
            })
          } else {
            productFiles.push({
              fileUrl: '',
              isDelete: true,
              position: 1,
            })
          }
        }
        //to check whether the file is same as API data, if not we have to upload it to the S3 bucket
        const OtherSameAsAPiData =
          getProductByIdData.getProductById?.productFiles.filter(
            (file: any) => file?.position === 2
          )[0]?.fileUrl === otherFile
        if (!OtherSameAsAPiData) {
          if (otherFile) {
            OtherUrl = await uploadFiles(
              [otherFile],
              false,
              '',
              `Productfiles/${values.productName.replaceAll(' ', '-')}`
            )
            productFiles.push({
              fileUrl: OtherUrl[0],
              position: 2,
            })
          } else {
            productFiles.push({
              fileUrl: '',
              isDelete: true,
              position: 2,
            })
          }
        }
        await updateProduct({
          variables: {
            updateProductInput: {
              ...formData,
              id: formik.getFieldMeta('id').value,
              productFiles,
            },
          },
        })
      }
    },
  })

  useEffect(() => {
    if (!formik.isSubmitting) {
      return
    }
    if (Object.keys(formik.errors).length > 0) {
      const errorElement = document.getElementById(Object.keys(formik.errors)[0])
      errorElement?.scrollIntoView({behavior: 'smooth', block: 'center'})
      errorElement?.focus({preventScroll: true})
    }
  }, [formik])

  const handleModalClose = () => {
    handleClose()
    setLmiApproved('')
    setSelectedProgram([])
    setTC(null)
    setEFL(null)
    setOtherFile(null)
  }
  return createPortal(
    <Modal
      id='kt-modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-650px'
      show={show}
      onHide={() => handleModalClose()}
      backdrop={true}
    >
      <div className='modal-header'>
        <h2>{status} Product</h2>
        <div className='d-flex gap-5'>
          <ToggleButton
            leftText='Inactive'
            rightText='Active'
            leftTextClassName='badge-light-danger'
            rightTextClassName='badge-light-success'
            isActive={activeStatus}
            onChange={(checked) => setActiveStatus(checked)}
          />
          <div
            className='btn btn-sm btn-icon btn-active-color-primary'
            onClick={() => handleModalClose()}
          >
            <SVG src={closeSymbol}></SVG>
          </div>
        </div>
      </div>
      <div className='hover-scroll-overlay-y mh-550px product-form'>
        {loading ? (
          <div className='text-center mh-400px'>
            <Spinner animation='border' className='text-gray-600 text-center' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </Spinner>
          </div>
        ) : (
          <div className='mh-450px overflow-auto modal-body mx-10 ps-8 pe-2 py-0'>
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              {/* Product Name */}
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Campaign</span>
                </label>
                <input
                  type='text'
                  disabled={method === 'edit'}
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Enter Campaign'
                  id='productName'
                  maxLength={51}
                  {...formik.getFieldProps('productName')}
                />
                {formik.errors.productName && formik.touched.productName && (
                  <div className='fv-plugins-message-container'>
                    <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                      {formik.errors.productName}
                    </div>
                  </div>
                )}
              </Col>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Product</span>
                </label>
                <Dropdown
                  fieldName='product'
                  optionList={productType}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
            </Row>
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Customer Type</span>
                </label>
                <Dropdown
                  fieldName='customerType'
                  optionList={customerTypeData}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Solar Farm Name</span>
                </label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Enter Solar Farm Name'
                  id='solarFarmName'
                  maxLength={51}
                  {...formik.getFieldProps('solarFarmName')}
                />
                {formik.errors.solarFarmName && formik.touched.solarFarmName && (
                  <div className='fv-plugins-message-container'>
                    <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                      {formik.errors.solarFarmName}
                    </div>
                  </div>
                )}
              </Col>
            </Row>
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Billing Method</span>
                </label>
                <Dropdown
                  fieldName='billingMethod'
                  optionList={billingMethodOptions}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Discount %</span>
                </label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Enter discount'
                  id='discount'
                  maxLength={51}
                  {...formik.getFieldProps('discount')}
                />
                {formik.errors.discount && formik.touched.discount && (
                  <div className='fv-plugins-message-container'>
                    <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                      {formik.errors.discount}
                    </div>
                  </div>
                )}
              </Col>
            </Row>
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Deal Source Tier</span>
                </label>
                <Dropdown
                  fieldName='dealSourceTier'
                  optionList={dealSourceTier}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Available Customers</span>
                </label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Enter Available Customers'
                  id='availableCustomers'
                  maxLength={51}
                  {...formik.getFieldProps('availableCustomers')}
                />
                {formik.errors.availableCustomers && formik.touched.availableCustomers && (
                  <div className='fv-plugins-message-container'>
                    <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                      {formik.errors.availableCustomers}
                    </div>
                  </div>
                )}
              </Col>
            </Row>
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Credit Check Required</span>
                </label>
                <Dropdown
                  fieldName='creditCheckRequired'
                  optionList={[
                    {value: 'Yes', label: 'Yes', id: 'True'},
                    {value: 'No', label: 'No', id: 'False'},
                  ]}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>State</span>
                </label>
                <Dropdown
                  fieldDisabled={method === 'edit'}
                  fieldName='state'
                  optionList={state}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
            </Row>
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Utility</span>
                </label>
                <Dropdown
                  fieldDisabled={method === 'edit'}
                  fieldName='utility'
                  optionList={utilityData}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Assign to TPV Script</span>
                </label>
                <Dropdown
                  fieldName='script'
                  optionList={tpvScript}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
            </Row>

            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Additional Information</span>
                </label>
                <Stack gap={4}>
                  {noteList.map((noteItem: any, index: number) => {
                    return (
                      <div key={index}>
                        <input
                          type='text'
                          id={noteItem.fieldName}
                          placeholder={noteItem.placeHolderText}
                          className='form-control form-control-solid'
                          {...formik.getFieldProps(noteItem.fieldName)}
                        />
                      </div>
                    )
                  })}
                </Stack>
              </Col>
              {method === 'edit' ? (
                limStatus && (
                  <Col sm md lg={6}>
                    <label className='d-flex align-items-center mb-2'>
                      <span className='fs-6 fw-semibold lh-23'>Benefit Program</span>
                    </label>
                    <MultiSelect
                      options={benefitProgaramModifications}
                      value={selectedProgram}
                      className='create-script-dropdown'
                      onChange={setSelectedProgram}
                      labelledBy='Select'
                    />
                  </Col>
                )
              ) : (
                <Col sm md lg={6}>
                  <label className='d-flex align-items-center mb-2'>
                    <span className='fs-6 fw-semibold lh-23'>Benefit Program</span>
                  </label>
                  <MultiSelect
                    options={benefitProgaramModifications}
                    value={selectedProgram}
                    className='create-script-dropdown'
                    onChange={setSelectedProgram}
                    labelledBy='Select'
                  />
                </Col>
              )}
            </Row>
            {(featureFlags?.getClientFeatureFlags?.enableSmsDocumentVerification ||
              featureFlags?.getClientFeatureFlags?.enableEmailDocumentVerification) && (
              <>
                <p className='fw-semibold fs-6 mt-3'>Terms and Conditions</p>
                {TC ? (
                  <PdfPreview url={TC} isViewable removeFile={() => setTC(null)} />
                ) : (
                  <DragDrop
                    fileTypes={fileUploadFileType}
                    setFile={setTC}
                    label={'Click here to upload terms and conditions or drag and drop'}
                  />
                )}
                <p className='fw-semibold fs-6 mt-3'>Disclosure Statement</p>
                {EFL ? (
                  <PdfPreview url={EFL} isViewable removeFile={() => setEFL(null)} />
                ) : (
                  <DragDrop
                    fileTypes={fileUploadFileType}
                    setFile={setEFL}
                    label={'Click here to upload EFL or drag and drop'}
                  />
                )}

                <p className='fw-semibold fs-6 mt-3'>Other</p>
                {otherFile ? (
                  <PdfPreview url={otherFile} isViewable removeFile={() => setOtherFile(null)} />
                ) : (
                  <DragDrop
                    fileTypes={fileUploadFileType}
                    setFile={setOtherFile}
                    label={'Click here to upload other or drag and drop'}
                  />
                )}
              </>
            )}
          </div>
        )}

        <div
          className='modal-footer sticky-bottom bg-white'
          style={{borderRadius: '0 0 20px 20px', zIndex: '2'}}
        >
          <button type='button' className='btn btn-light' onClick={() => handleModalClose()}>
            Discard
          </button>
          <button
            className={'btn btn-primary'}
            data-kt-stepper-action='submit'
            onClick={(e) => formik.submitForm()}
          >
            {submitting
              ? method === 'Create'
                ? 'Creating product'
                : 'Updating product'
              : 'Submit'}
            {submitting && (
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            )}
          </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {SolarProductModal}
